import React, { useState, useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";;
import BrowserViewGlobal from "../../../Views/BrowserView";
import MobileViewGlobal from "../../../Views/MobileView";
import EventUserItem from "../../EventUserItem";

export default function EventVisitorList({
  isLoading,
  eventUserList,
  fetchEventUserLoadMore,
  selectedValues,
  getFilteredSelectedValues,
  me,
  nextUrl,
  MAX_INVITES,
  handleChange,
  isInviting,
  scrollableTarget,
  hasProfilePicture
}) {
  const [visitorList, setVisitorList] = useState([]);
  const [hasMore, setHasMore] = useState(true);

  const renderLoading = () => {
    return (
      <>
        {isLoading &&
          <p
            className={
              "user-wrapper__search-message user-wrapper__search-message--center"
            }
          >
            Loading...
          </p>
        }
      </>
    );
  };

  const createVisitorList = () => {
    eventUserList &&
      setVisitorList(
        eventUserList.filter(
          (item) =>
            item?.id !== me?.id && item?.user?.firstName && item?.user?.lastName
        ).sort((a, b) => {
            const order = [1, 2, 0];
            return order.indexOf(a.availability) - order.indexOf(b.availability);
        })
      );
  };

  const fetchMore = () => {
    if (nextUrl) {
      fetchEventUserLoadMore();

    } else {
      setHasMore(false);
    }
  };

  const renderInfiniteScrollList = (children, scrollableTarget = null) => {
    return (
      <>
        {visitorList && (
          <InfiniteScroll
            dataLength={visitorList.length}
            next={fetchMore}
            hasMore={hasMore}
            scrollableTarget={scrollableTarget}
            loader={renderLoading()}
          >
            <>{children}</>
          </InfiniteScroll>
        )}
      </>
    );
  };

  const renderEventUserItem = (item) => {
    return (
      <EventUserItem
        key={item.id}
        id={item.id}
        item={item}
        isSelected={selectedValues[item.id]}
        selectedValuesCount={getFilteredSelectedValues().length}
        MAX_INVITES={MAX_INVITES}
        handleChange={handleChange}
        hasProfilePicture={hasProfilePicture}
        isInviting={isInviting}
      />
    );
  };

  useEffect(() => {
    createVisitorList();
  }, [eventUserList]);

  return (
    <>
      <BrowserViewGlobal className="visitor-list">
        {renderInfiniteScrollList(
          <>
            {visitorList &&
              visitorList.map((item) => renderEventUserItem(item))}
          </>,
          scrollableTarget
        )}
      </BrowserViewGlobal>

      <MobileViewGlobal className="user-wrapper--min-top visitor-list">
        {renderInfiniteScrollList(
          <>
            {visitorList &&
              visitorList.map((item, index) => {
                return (
                  <div
                    className="user-wrapper__item-new-message user-wrapper__item-new-message--min-padd"
                    key={index}
                  >
                    {renderEventUserItem(item)}
                  </div>
                );
              })}
          </>
        )}
      </MobileViewGlobal>
    </>
  );
}
